import React, { useEffect, useState } from "react";
import feather from "feather-icons";
import EntriesCounter from "../../commonComponents/EntriesCounter/EntriesCounter";
import Input from "../../commonComponents/Input/Input";
import Table from "../../commonComponents/Table/Table";
import {
  inclusion_data,
  inclusion_loading,
  inclusion_page_details,
} from "../../redux/commonReducer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useFilter from "../../utils/Hooks/useFilter";
import {
  deleteInclusion,
  getInclusion,
  insertInclusion,
  updateInclusion,
} from "../../redux/actionCreator";
import Actions from "../../commonComponents/Actions/Actions";
import EditIcon from "../../assets/icons/EDIT.svg";
import DeleteIcon from "../../assets/icons/DELETE.svg";
import DeleteModal from "../../commonComponents/DeleteModal/DeleteModal";
import LoadingSpinner from "../../commonComponents/LoadingSpinner/LoadingSpinner";

export default function ManageInclusions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const data = useSelector(inclusion_data);
  const pageData = useSelector(inclusion_page_details);
  const loading = useSelector(inclusion_loading);

  const initialFilter = {
    page: 0,
    perPage: 10,
    sortColumn: "updated_date",
    sortValue: -1,
    keyword: "",
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [open, setOpen] = useState(false);
  const [inclusionData, setInclusionData] = useState({
    inclusion_name: "",
    id: "",
  });
  const [err, setErr] = useState({});

  const [filterData, setFilterData, F_navigate] = useFilter({
    initialFilter,
    dataFetch: (filter) => {
      getSearchDataHandler(filter);
    },
    dependency: [],
  });

  useEffect(() => {
    feather.replace();
  }, []);

  useEffect(() => {
    getSearchDataHandler(initialFilter);
  }, []);

  const getSearchDataHandler = (filter) => {
    let formData = new FormData();
    formData.append("page", filter.page);
    formData.append("perPage", filter.perPage);
    formData.append("sort_order", filter.sortValue);
    formData.append("sort_key", filter.sortColumn);
    formData.append("keyword", filter?.keyword?.trim() ?? "");
    dispatch(getInclusion(formData));
  };

  const showDeletePopup = (id) => {
    setShowDeleteModal(true);
    setDeleteID(id);
  };

  function filterHandler(key, value) {
    let filter;
    switch (key) {
      case "searchBox":
        filter = { ...filterData, ...value, page: 0 };
        break;
      case "clearSearch":
        filter = initialFilter;
        break;
      case "keyword":
        filter = { ...filterData, keyword: value, page: 0 };
        break;
      case "sort":
        filter = {
          ...filterData,
          sortColumn: value.key,
          sortValue: value.value,
        };
        break;
      case "page":
        filter = { ...filterData, page: value };
        break;
      case "entries":
        filter = { ...filterData, page: 0, perPage: parseInt(value) };
        break;
      default:
    }

    if (!filter) return;
    setFilterData(filter);
    getSearchDataHandler(filter);
  }

  const handleClose = () => {
    setDeleteID("");
    setShowDeleteModal(false);
  };

  const deleteHandler = () => {
    dispatch(
      deleteInclusion(deleteID, () => {
        setShowDeleteModal(false);
        setDeleteID("");
        if (data?.length == 1 && pageData?.pages > 1 && filterData?.page != 0) {
          setFilterData({
            ...filterData,
            page: filterData?.page - 1,
          });
          let formData = new FormData();
          formData.append("page", filterData?.page - 1);
          formData.append("perPage", filterData.perPage);
          formData.append("sort_order", filterData.sortValue);
          formData.append("sort_key", filterData.sortColumn);
          formData.append("keyword", filterData?.keyword?.trim() ?? "");
          dispatch(getInclusion(formData));
        } else {
          getSearchDataHandler(filterData);
        }
      })
    );
  };

  const onChangeHandler = (key, value) => {
    setInclusionData({
      ...inclusionData,
      [key]: value,
    });
    setErr({
      ...err,
      [key]: "",
    });
  };

  const validate = () => {
    let temp = {};
    if (!inclusionData?.inclusion_name?.trim()?.length) {
      temp = {
        ...temp,
        inclusion_name: "Please enter inclusion name",
      };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const onSubmitHandler = () => {
    if (validate()) {
      let raw = {
        inclusion_name: inclusionData?.inclusion_name?.trim(),
      };
      if (inclusionData?.id != "") {
        raw = {
          ...raw,
          id: inclusionData?.id,
        };
        dispatch(
          updateInclusion(raw, (res) => {
            if (res) {
              onCancelHandler();
              getSearchDataHandler(filterData);
            }
          })
        );
      } else {
        dispatch(
          insertInclusion(raw, (res) => {
            if (res) {
              onCancelHandler();
              getSearchDataHandler(filterData);
            }
          })
        );
      }
    }
  };

  const editHandler = (ele) => {
    setInclusionData({
      inclusion_name: ele?.inclusion_name,
      id: ele?._id,
    });
    setOpen(true);
  };

  const onCancelHandler = () => {
    setInclusionData({
      inclusion_name: "",
      id: "",
    });
    setOpen(false);
  };

  return (
    <div className="row">
      <div className="col">
        {open && (
          <div className="card">
            <div className="card-body">
              <div className="table__formAdd">
                <div className="col-md-12">
                  <label className="form-label">
                    Inclusion Name <em>*</em>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Type here"
                    onChange={(e) =>
                      onChangeHandler("inclusion_name", e?.target?.value)
                    }
                    value={inclusionData?.inclusion_name}
                  />
                  <small id="error" className="error">
                    {err?.inclusion_name}
                  </small>
                </div>
                <div className="actions">
                  <button
                    className="btn btn-primary"
                    onClick={() => onSubmitHandler()}
                  >
                    {inclusionData?.id ? "Update" : "Add"}
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => onCancelHandler()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="card">
          <div className="card-body">
            <div className="table__add border-style">
              <h5 className="card-title ">Manage Inclusion</h5>
              <button
                className="btn btn-primary"
                onClick={() => setOpen(!open)}
              >
                {open ? "Back To Manage" : "Add Inclusion"}
              </button>
            </div>
            <div className="search__head">
              <div className="count">
                <EntriesCounter
                  value={filterData.perPage}
                  onChange={(e) => {
                    filterHandler("entries", e);
                  }}
                />
              </div>
              <div className="search">
                <Input
                  value={filterData.keyword}
                  type="text"
                  className="css-inp-esc2 search"
                  // icon={GenericSearchIcon}
                  placeholder={"Search Here"}
                  reverse
                  width="300px"
                  field="keyword"
                  showCloseBtn
                  onChange={(e) => !e && filterHandler("keyword", e)}
                  onSubmit={(e) => {
                    filterHandler("keyword", e);
                  }}
                  onIconClick={(e) => {
                    filterHandler("keyword", e);
                  }}
                />
              </div>
            </div>
            {loading ? (
              <LoadingSpinner height={"200px"} />
            ) : (
              <Table
                titles={[
                  {
                    title: "Sl.No",
                    key: "sl_no",
                    width: "40px",
                  },
                  {
                    title: "Inclusion Name",
                    key: "inclusion_name",
                    sort: true,
                    width: "750px",
                  },

                  { title: "Action", key: "action", width: "100px" },
                ]}
                content={data?.map((item, i) => ({
                  sl_no: filterData.page * filterData.perPage + (i + 1),
                  inclusion_name: item?.inclusion_name,
                  action: (
                    <Actions
                      buttons={{
                        edit: EditIcon,
                        delete: DeleteIcon,
                      }}
                      onEdit={() => editHandler(item)}
                      onDelete={() => showDeletePopup(item?._id)}
                    />
                  ),
                }))}
                onSort={(e) => filterHandler("sort", e)}
                page={filterData.page}
                pagesCount={pageData?.pages}
                pageStatus={pageData?.status}
                onPageChange={(e) => {
                  filterHandler("page", e.selected);
                }}
                sortValue={{
                  key: filterData.sortColumn,
                  value: filterData.sortValue,
                }}
              />
            )}
          </div>
        </div>
      </div>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleClose={handleClose}
        deleteHandler={deleteHandler}
        title={"Delete Inclusions"}
      />
    </div>
  );
}
